import { combineReducers } from 'redux';
import { authReducer } from './widgets/Auth';
import { tableSettingsReducer } from './widgets/TableSettings';
import { userReducer } from './widgets/User';
import { webSocketReducer } from './widgets/WebSocket';
import { roundStateReducer } from './widgets/RoundStates';
import { roundStatusReducer } from './widgets/RoundStatuses';
import { betRepeatReducer } from './widgets/BetRepeat';
import { betDoubleReducer } from './widgets/BetDouble';
import { toastReducer } from './widgets/Toast';
import { bettingTimeReducer } from './widgets/BettingTime';
import { activeChipReducer } from './widgets/ActiveChip';
import { winStatusReducer } from './widgets/WinStatus';
import { noticesReducer } from './widgets/Notices';
import { soundSettingsReducer } from './widgets/SoundSettings';
import { videoSettingsReducer } from './widgets/VideoSettings';
import { settingsPanelReducer } from './widgets/SettingsPanel';
import { generalSettingsReducer } from './widgets/GeneralSettings';
import { gameRulesReducer } from './widgets/GameRules';
import { roundWinnersReducer } from './widgets/WinnersTicker';
import { jackpotReducer } from './widgets/Jackpot';
import { historyReducer } from './widgets/History';
import { chatPanelReducer } from './widgets/ChatPanel';
import { gameTypeReducer } from './gameTypeReducer';
import { rouletteBetReducer } from './widgets/RouletteBet';
import { lastWinnersReducer } from './widgets/LastWinners';
import { hotColdAnalyticsReducer } from './widgets/HotColdAnalytics';

const rouletteReducer = combineReducers({
  rouletteBetReducer,
  lastWinnersReducer,
  hotColdAnalyticsReducer,
});

export const rootReducer = combineReducers({
  webSocketReducer,
  authReducer,
  activeChipReducer,
  tableSettingsReducer,
  userReducer,
  winStatusReducer,
  roundStateReducer,
  roundStatusReducer,
  betDoubleReducer,
  betRepeatReducer,
  toastReducer,
  bettingTimeReducer,
  noticesReducer,
  soundSettingsReducer,
  videoSettingsReducer,
  generalSettingsReducer,
  gameRulesReducer,
  settingsPanelReducer,
  roundWinnersReducer,
  jackpotReducer,
  historyReducer,
  chatPanelReducer,
  gameTypeReducer,
  rouletteReducer,
});
